/* eslint-disable react/prop-types */
import React from 'react';
import { _RedStrikeThrough, _BlackText } from "../../style/CommonStyles";
var RedStrikeThrough = function RedStrikeThrough(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_RedStrikeThrough, null, /*#__PURE__*/React.createElement(_BlackText, null, children));
};
export default RedStrikeThrough;